document.addEventListener('click', function (event) {
  const link = event.target.closest('.wm-care a[href^="#wm-"]');
  if (!link) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const alignTarget = function () {
    const header = document.getElementById('shopify-section-header');
    const headerStyle = header ? getComputedStyle(header).position : '';
    const offset = header && (headerStyle === 'sticky' || headerStyle === 'fixed')
      ? header.getBoundingClientRect().height + 24 : 24;
    window.scrollBy({ top: target.getBoundingClientRect().top - offset, behavior: 'instant' });
  };
  alignTarget();
  requestAnimationFrame(alignTarget);
  history.replaceState(null, '', link.getAttribute('href'));
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
}, true);
